import { render } from "./BottomButtonsComponent.vue?vue&type=template&id=1a0be3dc&scoped=true"
import script from "./BottomButtonsComponent.vue?vue&type=script&lang=js"
export * from "./BottomButtonsComponent.vue?vue&type=script&lang=js"

import "./BottomButtonsComponent.vue?vue&type=style&index=0&id=1a0be3dc&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0be3dc"]])

export default __exports__